import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SubjectManagementPage } from '@/features/question/pages/SubjectManagementPage';
import { subjectSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/subjects')({
  validateSearch: subjectSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Subject Management">
      <Suspense fallback={<PageLoader />}>
        <SubjectManagementPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
